import { CreateChildRecord, CreateChildRecordProps, DataFocusViewDialogDefault, DataFocusViewDialogDefaultProps } from './variants';

export type DataFocusViewDialogProps =
    | ({
          variant?: 'default' | undefined;
      } & DataFocusViewDialogDefaultProps)
    | ({ variant: 'create-child-record' } & CreateChildRecordProps);

export const DataFocusViewDialog = ({ variant, ...props }: DataFocusViewDialogProps) => {
    if (variant === 'create-child-record') {
        return <CreateChildRecord {...(props as CreateChildRecordProps)} />;
    }

    return <DataFocusViewDialogDefault {...props} />;
};
